import { create as mapLegacyHandlerForm } from '@vlabs/api-bindings/src/luna-client/handlers/mappers/schemes/create.js';

const getSupportedStoragePolicy = (storagePolicy) => {
  if (!storagePolicy) return undefined;

  return {
    callbacks: storagePolicy.callbacks,
    face_sample_policy: storagePolicy.face_sample_policy,
    body_sample_policy: storagePolicy.body_sample_policy,
    image_origin_policy: storagePolicy.image_origin_policy,
    event_policy: storagePolicy.event_policy,
  };
};

function mapHandlerFormToRequest(values) {
  const legacyPolicies = mapLegacyHandlerForm(values).policies ?? {};

  return {
    description: values.description,
    owner_department_id: values.owner_department_id,
    policies: {
      detect_policy: legacyPolicies.detect_policy,
      extract_policy: legacyPolicies.extract_policy,
      match_policy: values.matchPolicy,
      storage_policy: getSupportedStoragePolicy(legacyPolicies.storage_policy),
      conditional_tags_policy: legacyPolicies.conditional_tags_policy,
    },
  };
}

export { mapHandlerFormToRequest };
